(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["campaign-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.matsuCampaignCartPricingLoaded) return;
    window.matsuCampaignCartPricingLoaded = true;

    const selector = '[data-campaign-cart-price]';
    const getMoneyFormat = () => {
      if (!window.theme) return undefined;
      return window.theme.settings?.currency_code_enable ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
    };
    const formatMoney = (cents) => {
      if (window.theme?.formatMoney) return window.theme.formatMoney(cents, getMoneyFormat());
      return `${(cents / 100).toFixed(2)} TL`;
    };
    const hideNativePrices = () => {
      document.querySelectorAll(selector).forEach((badge) => {
        const productDetailBlock = badge.closest('.product__price-and-badge');
        const productDetailPrice = productDetailBlock?.querySelector('.product__price-wrapper');
        const productGridInfo = badge.closest('.product-grid-item__info');
        const productGridPrice = productGridInfo?.querySelector('.product-grid-item__price');
        const productGridInfoContent = productGridPrice?.closest('.product-grid-item__info-content');
        const productGridSeparator = productGridInfoContent?.querySelector('.product-grid-item__info-separator');

        productDetailPrice?.classList.add('campaign-native-price-hidden');
        productGridPrice?.classList.add('campaign-native-price-hidden');
        productGridSeparator?.classList.add('campaign-native-price-hidden');
      });
    };
    const updateCampaignPrices = () => {
      const badges = document.querySelectorAll(selector);
      if (!badges.length) return;

      badges.forEach((badge) => {
        const price = Number(badge.dataset.campaignFixedPrice || badge.dataset.firstPrice);
        const comparePrice = Number(badge.dataset.comparePrice);
        const compareEl = badge.querySelector('[data-campaign-compare]');
        const amountEl = badge.querySelector('[data-campaign-amount]');

        if (compareEl && comparePrice > 0) compareEl.innerHTML = formatMoney(comparePrice);
        if (amountEl && price > 0) amountEl.innerHTML = formatMoney(price);
      });
    };
    const syncFixedCampaignAtcPrices = (root = document) => {
      const scope = root?.querySelectorAll ? root : document;

      scope.querySelectorAll('[data-atc-button][data-campaign-fixed-price]').forEach((wrap) => {
        const price = Number(wrap.dataset.campaignFixedPrice);
        const quantityInput = wrap.closest('form')?.querySelector('[name="quantity"]');
        const quantity = Math.max(Number(quantityInput?.value) || 1, 1);
        const priceEl = wrap.querySelector('[data-product-price]');
        const compareEl = wrap.querySelector('[data-compare-price]');

        if (priceEl && price > 0) priceEl.innerHTML = formatMoney(price * quantity);
        if (compareEl) {
          compareEl.classList.add('hidden');
          compareEl.innerHTML = '';
        }
      });
    };
    const refreshCampaignPrices = () => {
      if (!document.querySelector(selector) && !document.querySelector('[data-atc-button][data-campaign-fixed-price]')) return;

      hideNativePrices();
      updateCampaignPrices();
      syncFixedCampaignAtcPrices();
    };

    const initCampaignPrices = () => {
      hideNativePrices();
      refreshCampaignPrices();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCampaignPrices);
    } else {
      initCampaignPrices();
    }

    document.addEventListener('theme:cart:added', refreshCampaignPrices);
    document.addEventListener('theme:cart:loaded', refreshCampaignPrices);
    document.addEventListener('theme:variant:change', (event) => {
      requestAnimationFrame(() => syncFixedCampaignAtcPrices(event.target));
    });
    document.addEventListener('change', (event) => {
      if (!event.target.matches('[name="quantity"]')) return;
      requestAnimationFrame(() => syncFixedCampaignAtcPrices(event.target.closest('form') || document));
    });
    document.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-quantity-button]');
      if (!quantityButton) return;
      requestAnimationFrame(() => syncFixedCampaignAtcPrices(quantityButton.closest('form') || document));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
